import { useRegisterSW } from "virtual:pwa-register/react";
import { UpdateBanner } from "./UpdateBanner";

/** "New version — reload". Never reloads on its own, so an edit in progress is safe (SPEC §11.4). */
export function UpdatePrompt({ placement = "bottom" }: { placement?: "top" | "bottom" }) {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) {
        setInterval(() => void registration.update(), 60 * 60 * 1000);
      }
    },
  });
  if (!needRefresh) {
    return null;
  }
  return (
    <UpdateBanner
      placement={placement}
      onLater={() => setNeedRefresh(false)}
      onReload={() => void updateServiceWorker(true)}
    />
  );
}
